module.exports = __webpack_public_path__ + "static/media/account.93c780c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/account.svg
// module id = 462
// module chunks = 0